<script setup lang="ts">
import SystemUiconsLightbulbOn from "~/components/icons/SystemUiconsLightbulbOn.vue";
import ClarityPiggyBankLine from "~/components/icons/ClarityPiggyBankLine.vue";
import MaterialSymbolsLightHeartPlusOutline from "~/components/icons/MaterialSymbolsLightHeartPlusOutline.vue";
import MaterialSymbolsLightMoreTimeRounded from "~/components/icons/MaterialSymbolsLightMoreTimeRounded.vue";
import AccountGroup from "~/components/icons/AccountGroup.vue";

const benefits = [
    {
        icon: "MaterialSymbolsLightHeartPlusOutline",
        title: "Health & Wellness",
        reasons: [
            "American Book Company provides a comprehensive health care plan consisting of medical, dental, and vision benefit options.",
            "We also provide life insurance, short and long term disability, and an employee assistance program.",
        ],
    },
    {
        icon: "MaterialSymbolsLightMoreTimeRounded",
        title: "Flexible Schedule & Paid Time Off",
        reasons: [
            "American Book Company offers flexible work hours for full and part time employees.",
            "Full time employees begin accruing paid vacation right away.",
        ],
    },
    {
        icon: "ClarityPiggyBankLine",
        title: "Planning for the Future",
        reasons: [
            "American Book Company offers a 401(k) plan with employer match.",
            "Employees are eligible to participate after six months of employment.",
        ],
    },
    {
        icon: "SystemUiconsLightbulbOn",
        title: "Learning & Development",
        reasons: [
            "To encourage professional development, American Book Company offers a tuition assistance program to eligible employees who complete job-related courses.",
            "All full-time employees with one year or more of service are eligible to participate in the program.",
        ],
    },
];

const diversityCulture = {
    icon: "SystemUiconsLightbulbOn",
    title: "Diversity & Culture",
    reasons: [
        "We embrace the diversity of our team and make inclusion part of our core values.",
        "We celebrate the unique perspectives and skills each team member brings to work every day.",
        "A diverse team makes our solutions–the books and digital programs used in classrooms throughout the country–more accessible and engaging for all.",
        "American Book Company provides equal opportunities to all employees and applicants for employment without regard to race, religion, color, age, sex, national origin, sexual orientation, gender identity, genetic disposition, neurodiversity, disability, veteran status or any other protected category under federal, state, and local law.",
    ],
};

const icons = {
    MaterialSymbolsLightHeartPlusOutline: MaterialSymbolsLightHeartPlusOutline,
    MaterialSymbolsLightMoreTimeRounded: MaterialSymbolsLightMoreTimeRounded,
    ClarityPiggyBankLine: ClarityPiggyBankLine,
    SystemUiconsLightbulbOn: SystemUiconsLightbulbOn,
    AccountGroup: AccountGroup,
};

const liStyles = "border-l-4 border-abc-blue-lighter px-4 py-2 odd:bg-abc-gray last:pb-4 first:pt-4";
</script>

<template>
    <div class="container py-10 text-center">
        <H2Heading>Benefits Of Working at ABC</H2Heading>
        <p class="mb-4 text-gray-600">
            Our employees are our most valuable assets. We offer competitive benefits and a great work environment.
        </p>
        <div class="mx-auto grid grid-cols-1 gap-x-4 gap-y-8 text-left md:grid-cols-2 lg:w-3/4">
            <div v-for="benefit in benefits" :key="benefit.title" class="flex items-start">
                <Component :is="icons[benefit.icon]" class="text-abc-blue w-10 flex-none" />

                <div class="flex-1 px-4">
                    <h3-heading>{{ benefit.title }}</h3-heading>
                    <ul class="text-gray-600">
                        <li
                            v-for="(reason, index) in benefit.reasons"
                            :key="benefit.title + 'reason' + index"
                            :class="liStyles"
                        >
                            {{ reason }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="mx-auto mt-6 text-left lg:w-3/4">
            <div class="flex items-start">
                <AccountGroup class="text-abc-blue w-10 flex-none" />
                <div class="flex-1 px-4">
                    <h3-heading>{{ diversityCulture.title }}</h3-heading>
                    <ul class="text-gray-600">
                        <li
                            v-for="(reason, index) in diversityCulture.reasons"
                            :key="diversityCulture.title + 'reason' + index"
                            :class="liStyles"
                        >
                            {{ reason }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
